import { render, staticRenderFns } from "./SupervisionDiffDetailMenu.vue?vue&type=template&id=8c333224&"
import script from "./SupervisionDiffDetailMenu.vue?vue&type=script&lang=js&"
export * from "./SupervisionDiffDetailMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports